import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import profileImage from '../assets/image/ml.jpg';
import CV from '../assets/doc/CV_ML.pdf';
import GitHubActivity from '../components/GitHubActivity';
import { LanguageContext } from '../context/LanguageContext';

const Home = () => {
  const { t } = useContext(LanguageContext);

  return (
    <div className="min-h-screen">
      <div className="flex items-center py-20 pt-36">
        <div className="max-w-6xl mx-auto px-4">
          {/* Section principale */}
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-16">
            {/* Section texte */}
            <div className="flex-1 space-y-8 w-full lg:w-auto text-center lg:text-left">
              <div className="space-y-4">
                <h2 className="text-lg md:text-xl text-indigo-600 font-medium tracking-wide">
                  {t('role')}
                </h2>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-indigo-900 leading-tight">
                  Maxime London <span className="text-indigo-600">NJO</span>
                </h1>
              </div>
              
              <div className="space-y-6 text-base md:text-lg text-gray-600 leading-relaxed">
                <p className="relative pl-0 lg:pl-6 before:hidden lg:before:block before:content-[''] before:absolute before:left-0 before:top-0 before:w-1 before:h-full before:bg-indigo-600/30">
                  {t('greeting')}
                </p>
                <p>
                  {t('description')}
                </p>
              </div>
              
              {/* Boutons */}
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center lg:justify-start items-center">
                <a
                  href={CV}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full sm:w-auto flex-shrink-0 group relative px-8 py-4 bg-indigo-600 text-white rounded-lg overflow-hidden hover:scale-105 transition-all duration-300"
                >
                  <span className="relative z-10">{t('cv')}</span>
                  <div className="absolute inset-0 bg-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300"></div>
                  <span className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-indigo-800 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                </a>
                <Link
                  to="/contact"
                  className="w-full sm:w-auto flex-shrink-0 group relative px-8 py-4 bg-transparent text-indigo-600 rounded-lg overflow-hidden border-2 border-indigo-600 hover:scale-105 transition-all duration-300"
                >
                  <span className="relative z-10 group-hover:text-white transition-colors duration-300">{t('contactMe')}</span>
                  <div className="absolute inset-0 bg-indigo-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
                </Link>
              </div>
            </div>

            {/* Section image */}
            <div className="flex-1 flex justify-center w-full lg:w-auto">
              <div className="w-72 h-96 md:w-96 md:h-[28rem] rounded-lg overflow-hidden">
                <img
                  src={profileImage}
                  alt="Maxime London NJO"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Section GitHub Activity */}
      <div className="max-w-6xl mx-auto px-4 pb-20">
        <GitHubActivity />
      </div>
    </div>
  );
};

export default Home; 